import React from 'react';
import { FormattedMessage } from 'react-intl';

const HELP_URL = 'https://helpdesk.bitrix24.com.br/open/9612023/';

export default function PowerzapNotice() {
	return (
		<div className="powerzap-notice">
			<div className="powerzap-notice-box">
				<FormattedMessage id="pz_notice" />
			</div>
			<p className="powerzap-notice-link">
				<FormattedMessage
					id="pz_notice_link"
					values={{
						link: (chunks) => (
							<a href={HELP_URL} target="_blank" rel="noopener noreferrer">
								{chunks}
							</a>
						),
					}}
				/>
			</p>
		</div>
	);
}
